// extracted by mini-css-extract-plugin
export default {"container":"wWKA+","searchInput":"XaQBN","trendingSearch":"fhQLP","nonTrendingSearch":"Ysz0K","searchLink":"PG+wU"};